(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["book-promo-popup"] && !Shopify.designMode) return;
  try {
    
  class BookPromoPopup extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.closeButtons = Array.from(this.querySelectorAll('[data-book-promo-close]'));
      this.onKeyDown = this.onKeyDown.bind(this);
      this.closeButtons.forEach((button) => {
        button.addEventListener('click', () => this.hide());
      });
      if (window.Shopify && Shopify.designMode) {
        this.section = this.closest('.shopify-section');
        if (this.section) {
          this.section.addEventListener('shopify:section:select', () => this.show());
          this.section.addEventListener('shopify:section:deselect', () => this.hide());
        }
        return;
      }
      if (this.hasAttribute('only-once') && localStorage.getItem(this.storageKey) === 'true') {
        return;
      }
      this.timer = setTimeout(() => this.show(), this.apparitionDelay);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('keydown', this.onKeyDown);
      document.documentElement.classList.remove('book-promo-popup-lock');
    }

    get apparitionDelay() {
      return parseInt(this.getAttribute('apparition-delay') || '10', 10) * 1000;
    }

    get storageKey() {
      return 'theme:book-promo-popup-appeared';
    }

    show() {
      if (this.hasAttribute('open')) return;
      this.setAttribute('open', '');
      document.documentElement.classList.add('book-promo-popup-lock');
      document.addEventListener('keydown', this.onKeyDown);
      const closeButton = this.querySelector('.book-promo-popup__close');
      if (closeButton) closeButton.focus();
      if (!(window.Shopify && Shopify.designMode) && this.hasAttribute('only-once')) {
        localStorage.setItem(this.storageKey, 'true');
      }
    }

    hide() {
      if (!this.hasAttribute('open')) return;
      this.removeAttribute('open');
      document.documentElement.classList.remove('book-promo-popup-lock');
      document.removeEventListener('keydown', this.onKeyDown);
    }

    onKeyDown(event) {
      if (event.key === 'Escape') {
        this.hide();
        return;
      }
      if (event.key !== 'Tab' || !this.hasAttribute('open')) return;
      const focusable = Array.from(
        this.querySelectorAll('a[href], button:not([tabindex="-1"]), textarea, input, select, [tabindex]:not([tabindex="-1"])')
      ).filter((node) => !node.hasAttribute('disabled') && node.offsetParent !== null);
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  if (!customElements.get('book-promo-popup')) {
    customElements.define('book-promo-popup', BookPromoPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
